import { Typography, SubjectPropertyIcon } from "@avenue-8/sidekick-ui";
import {
  NeighborhoodMapSectionView,
  PropertyPhoto,
} from "@cma/presentation-generation-logic";
import { PresentationSectionViewProps } from "../PresentationSectionProps";
import { GoogleMapPrint } from "./components/GoogleMapPrint";
import { getPropertyStatusColor } from "./helpers/get-property-status-colors";
import { PrintPaper, PrintPage } from "../../shared/Print.styles";
import {
  MapLegend,
  BulletIcon,
  MapLegendItem,
  MapContainer,
  MapWrapperPrint,
} from "./NeighborhoodMap.styles";

interface Props
  extends PresentationSectionViewProps<NeighborhoodMapSectionView> {
  galleries?: { [key: string]: PropertyPhoto[] };
}

export const NeighborhoodMapPrint = (props: Props) => {
  const { sectionView } = props;
  const { properties: allProperties } = sectionView;

  const properties = allProperties?.filter((x) => x.lat && x.lng) ?? [];

  if (!properties || properties.length === 0) {
    return null;
  }

  return (
    <PrintPaper>
      <PrintPage>
        <Typography variant="h5" mb={3} textAlign="center">
          The Neighborhood at a Glance
        </Typography>

        <MapWrapperPrint>
          <MapContainer data-testid="neighborhood-map-container">
            <GoogleMapPrint properties={properties} />
          </MapContainer>
        </MapWrapperPrint>

        <MapLegend data-testid="neighborhood-map-legend" $displayMode="print">
          {Boolean(properties.find((p) => p.type === "subject")) && (
            <MapLegendItem>
              <SubjectPropertyIcon />
              Subject Property
            </MapLegendItem>
          )}
          <MapLegendItem>
            <BulletIcon
              markerColor={getPropertyStatusColor("comparable-sold")}
            />
            Comparable Sold
          </MapLegendItem>
          <MapLegendItem>
            <BulletIcon
              markerColor={getPropertyStatusColor("comparable-pending")}
            />
            Comparable Pending
          </MapLegendItem>
          <MapLegendItem>
            <BulletIcon
              markerColor={getPropertyStatusColor("comparable-active")}
            />
            Comparable Active
          </MapLegendItem>
          <MapLegendItem>
            <BulletIcon markerColor={getPropertyStatusColor("other")} />
            Other
          </MapLegendItem>
        </MapLegend>
      </PrintPage>
    </PrintPaper>
  );
};
